import type { Circle } from "../circle.types";

/**
 * A circle is visible to participants only when its CircleGroup explicitly
 * opts in via display_options.is_visible === true. The default is hidden.
 */
export function isCircleVisible(circle: Circle): boolean {
  return circle.display_options?.is_visible === true;
}
